var exports = {
  "k": "xfd349460--36d01d--container" + " " + __webpack_require__(27451)["T"],
  "P": "xfd349460--36d01d--label",
};

module.exports = exports;
